import { render, staticRenderFns } from "./ForumHome.vue?vue&type=template&id=78f0cc6e&"
import script from "./ForumHome.vue?vue&type=script&lang=js&"
export * from "./ForumHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports